
import { mapState, mapMutations } from 'vuex';
import Field from '@/components/ui/field.vue';

export default {
  name: 'MbWay',

  components: {
    Field,
  },

  data() {
    return {
      phone: null,
      active: false,
    };
  },

  computed: {
    ...mapState(['order', 'patientId', 'marketing', 'method']),
  },

  watch: {
    phone() {
      this.$emit('clearErrors');
    },
    method(value) {
      this.active = value === 'mbway';
    },
    active(value) {
      if (value) {
        this.setMethod('mbway');
      } else if (this.method === 'mbway') {
        this.setMethod('null');
      }
    },
  },

  mounted() {
    this.phone = this.order?.address?.phone;

    if (this.method === 'mbway') {
      setTimeout(() => {
        this.active = true;
      }, 500);
    }
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    ...mapMutations(['setMethod', 'setMbwayPending']),

    async pay() {
      this.$bolev.metaEvent({
        type: 'paymentInitiated',
        patientId: this.patientId,
      });
      try {
        const { data } = await this.$bolev.hiPay({
          data: {
            payment_product: 'mbway',
            phone: this.phone,
          },
          patientId: this.patientId,
          orderId: this.order.id,
          marketing: this.marketing,
        });
        switch (data.state) {
          case 'pending':
            this.setMbwayPending(true);
            this.interval = setInterval(() => {
              this.checkStatus(data.paymentId);
            }, 3000);
            setTimeout(() => {
              clearInterval(this.interval);
              this.$emit('fail');
            }, 400000);
            break;
          case 'completed':
            this.$emit('success', { method: 'mbway', state: data.state });
            break;
          case 'forwarding':
            window.location.href = data.url;
            break;
          case 'declined':
          case 'error':
          case 'unknown':
          default:
            this.$emit('fail', data);
            break;
        }
      } catch (e) {
        this.$emit('fail', e.response.data.message);
      }
    },

    async checkStatus(id) {
      try {
        const { data } = await this.$bolev.hiPayCheckStatus({
          id,
        });
        if (data.paid) {
          this.setMbwayPending(false);
          this.$emit('success', { method: 'mbway', state: data.state });
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
